import { isEmpty, isObject } from 'lodash';

/**
 * Do a deep copy of an object, no references to the original are retained.
 * Useful when dealing with recoil state objects which are non-configurable and read only
 * to make a copy and modify before updating the state again
 *
 * @param obj
 * @returns deep copy of the object passed in
 */
export const deepCopy = (obj: object) => {
  return structuredClone(obj);
};

export const debouncePromise = <T extends Array<any>, U>(
  fn: (...args: T) => U,
  time: number,
) => {
  let timerId: ReturnType<typeof setTimeout> | undefined = undefined;

  return function debounced(...args: T) {
    if (timerId) {
      clearTimeout(timerId);
    }

    return new Promise((resolve) => {
      timerId = setTimeout(() => resolve(fn(...args)), time);
    });
  };
};

export type Field = { field: string; defaultValue: any };
export type KeyMap = {
  [key: string]: any;
};

export const sanitizeObjectList = (objectList: KeyMap[], fields: Field[]) => {
  if (isEmpty(objectList) || isEmpty(fields)) return objectList;

  const fieldMap: KeyMap = {};
  const keys = fields.map(({ field, defaultValue }) => {
    fieldMap[field] = defaultValue;
    return field;
  });

  for (const object of objectList) {
    if (!isObject(object)) continue;

    for (const [key] of Object.entries(object)) {
      if (!keys.includes(key)) continue;
      object[key] = fieldMap[key];
    }
  }

  return objectList;
};
